import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { GradientButton } from '@/components/ui/gradient-button';

const CONSENT_KEY = 'aceena_cookie_consent';

export const CookieConsentBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasConsent = localStorage.getItem(CONSENT_KEY);
    if (!hasConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({
      accepted: true,
      timestamp: new Date().toISOString()
    }));
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
        >
          <div className="max-w-4xl mx-auto bg-primary/95 backdrop-blur-sm rounded-xl p-4 md:p-6 shadow-2xl border border-primary-foreground/10">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
              <div className="flex-1 space-y-2">
                <p className="text-primary-foreground text-sm md:text-base leading-relaxed">
                  Concordo com o tratamento dos meus dados pessoais de acordo com a{' '}
                  <Link 
                    to="/politica-de-privacidade" 
                    className="text-aceena-green hover:underline font-medium"
                  >
                    Política de Privacidade
                  </Link>{' '}
                  e autorizo o contato para oferta de produtos e serviços da Aceena e parceiros.
                </p>
                <p className="text-primary-foreground/70 text-xs md:text-sm leading-relaxed">
                  Os dados serão utilizados para elaboração de propostas personalizadas e integração com RDStation, e com as Locadoras parceiras, incluindo Localiza Meoo, Arval, LM, Movida, Original, entre outras.
                </p>
              </div>
              <GradientButton
                variant="primary"
                size="default"
                onClick={handleAccept}
                className="whitespace-nowrap"
              >
                Aceitar e Continuar
              </GradientButton>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
